module.exports = __webpack_public_path__ + "static/media/proj5_img3.978451c8.jpg";